// extracted by mini-css-extract-plugin
module.exports = {"w1ilkajt":"w1ilkajt","g1g5ab0v":"g1g5ab0v","sa154vv":"sa154vv"};